<div class="row">
    <div class="col-4">
        <div class="mb-3">
            <label class="form-label" [for]="'puntos_extras-' + (!accesoPublico ? pregunta.Id : null)">
                Puntos extras
            </label>
            <input type="number" min="0" [name]="'puntos_extras-' + (!accesoPublico ? pregunta.Id : null)"
                   [id]="'puntos_extras-' + (!accesoPublico ? pregunta.Id : null)" class="form-control"
                   [formControl]="puntosExtraControl" [disabled]="accesoPublico">
        </div>
    </div>
</div>
